export enum OfferType {
  SPEND_X_GET_Y = 'spendXGetY',
  FREE_SHIPPING = 'freeShipping',
  BASKET_DISCOUNT = 'basketDiscount',
}

export const offerTypeNameMap: Record<OfferType, string> = {
  [OfferType.SPEND_X_GET_Y]: 'X Harcamaya Y Hediye',
  [OfferType.FREE_SHIPPING]: 'Ücretsiz Kargo',
  [OfferType.BASKET_DISCOUNT]: 'Sepet İndirimi',
};
